Hop.defineModule('profile-redirect', (root, param) => {
    const $profiles = $(root);
    const $query = $('#q');

    function urlWithTrackingInfos(url) {
        const currentUrl = new Url();
        const searchEvent = $profiles.attr('data-se');
        const enhancedUrl = new Url(url);

        enhancedUrl.query = currentUrl.query;

        if (searchEvent) {
            enhancedUrl.query.searchid = searchEvent;
        }
        if (param.queryFamily) {
            enhancedUrl.query.fam = param.queryFamily;
        }
        if (param.queryCategory) {
            enhancedUrl.query.cat = param.queryCategory;
        }
        if (param.location) {
            enhancedUrl.query.location = param.location;
        }
        if (param.city) {
            enhancedUrl.query.city = param.city;
        }
        if (param.lat) {
            enhancedUrl.query.lat = param.lat;
        }
        if (param.lon) {
            enhancedUrl.query.lon = param.lon;
        }
        if (!param.noSearchBackLink && $query.length && $query.val()) {
            enhancedUrl.query.q = $query.val();
        }

        return enhancedUrl;
    }

    function hasToBeRedirectToProfile($target) {
        return $target.closest('.admin, .wishlist-heart, .wl-heart, [data-no-redirect-on-click]').length === 0;
    }

    function userWantToBeRedirected(e) {
        // verify user didn't press right click or left click on mouseup event
        return e.type === 'click' ? e.which !== 3 && e.which !== 2 : e.which === 2;
    }

    function redirectToProfileIfNeeded(e) {
        e.preventDefault();
        if (hasToBeRedirectToProfile($(e.target))) {
            const profileUrl = toAbsolutePath(
                $(e.target).closest('.item.media , .profileItem, .profile-card, .freelance-linkable').attr('data-target'),
            );

            const enhancedUrl = urlWithTrackingInfos(profileUrl);

            if (userWantToBeRedirected(e)) {
                openNewTab(enhancedUrl);

                if (param.gtmOnRedirect) {
                    Hop.gtm.push(param.gtmOnRedirect);
                }
            }
        }
    }

    function toAbsolutePath(url) {
        return url && url.charAt(0) !== '/' ? `/${url}` : url;
    }

    function openNewTab(url) {
        window.open(url);
    }

    $profiles.on('mousedown, click', '.freelance-linkable', redirectToProfileIfNeeded);
});
